import React, { useState } from 'react';
import { ContextHelpOverlay } from './ContextHelpOverlay';
import * as styles from './ContextHelp.css.ts';

interface ContextHelpButtonSimpleProps {
  helpContent: React.ReactNode;
  /** 具体的なヘルプ内容を説明するラベル（例: "Learn about density visualization options"） */
  ariaLabel?: string;
}

export const ContextHelpButtonSimple: React.FC<ContextHelpButtonSimpleProps> = ({
  helpContent,
  ariaLabel = 'Show context help'
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        className={styles.helpButton}
        onClick={() => setIsOpen(true)}
        title="Show help"
        aria-label={ariaLabel}
      >
        ?
      </button>

      {isOpen && (
        <ContextHelpOverlay
          helpContent={helpContent}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};